import { NavLink } from "react-router-dom";

const externalLinks = [
    { label: "Startseite", href: "https://glas-lilienthal.de/" },
    { label: "Über Uns", href: "https://glas-lilienthal.de/ueber-uns/" },
    { label: "Leistungen", href: "https://glas-lilienthal.de/glaserei-lilienthal/", hasArrow: true },
    { label: "Karriere", href: "https://glas-lilienthal.de/karriere/", hasArrow: true },
    { label: "Angebot-Generator", href: "https://glas-lilienthal.de/angebot-generator/", hasArrow: true },
];

const contactLink = { label: "Kontakt", href: "https://glas-lilienthal.de/kontakt-lilienthal/" };

function SiteHeader() {
    return (
        <header className="sticky top-0 z-40 bg-white">
            <div
                className="text-white"
                style={{
                    backgroundColor: "rgb(0, 73, 97)",
                    backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.55) 0%, rgb(0, 74, 97) 100%)",
                    fontFamily: "'Open Sans', Arial, sans-serif",
                }}
            >
                <div className="mx-auto flex w-full max-w-[1700px] flex-wrap items-center px-4 text-[15px] font-medium leading-[27px]">
                    <a
                        href="tel:+4942986994696"
                        className="inline-flex items-center gap-3 border-r border-white/25 px-5 py-3 transition-colors hover:text-slate-200"
                    >
                        <span aria-hidden="true" className="inline-flex h-4 w-4 items-center justify-center">
                            <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-current" focusable="false" aria-hidden="true">
                                <path d="M6.62 10.79a15.47 15.47 0 006.59 6.59l2.2-2.2a1 1 0 011-.24 11.36 11.36 0 003.58.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.49a1 1 0 011 1 11.36 11.36 0 00.57 3.58 1 1 0 01-.24 1z" />
                            </svg>
                        </span>
                        <span>04298 - 699 4696</span>
                    </a>
                    <a
                        href="mailto:info@glas-lilienthal.de"
                        className="inline-flex items-center gap-3 border-r border-white/25 px-5 py-3 transition-colors hover:text-slate-200"
                    >
                        <span aria-hidden="true" className="inline-flex h-4 w-4 items-center justify-center">
                            <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-current" focusable="false" aria-hidden="true">
                                <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4.24l-8 5-8-5V6l8 5 8-5z" />
                            </svg>
                        </span>
                        <span>info@glas-lilienthal.de</span>
                    </a>
                </div>
            </div>

            <div
                className="border-y border-slate-200/70"
                style={{
                    backgroundColor: "rgba(255, 255, 255, 0.88)",
                    backgroundImage: "repeating-linear-gradient(-45deg, rgba(15, 52, 71, 0.03) 0px, rgba(15, 52, 71, 0.05) 1px, transparent 1px, transparent 8px)",
                }}
            >
                <div className="mx-auto flex w-full max-w-[1700px] items-center justify-between gap-8 px-4 py-4">
                    <a href="https://glas-lilienthal.de/" className="flex items-center" aria-label="Glas Lilienthal">
                        <img src="/logo.png" alt="Glas Lilienthal" className="h-14 w-auto" loading="lazy" />
                    </a>

                    <nav
                        className="hidden items-center md:flex"
                        style={{ fontFamily: "'Open Sans', Helvetica, Arial, Lucida, sans-serif" }}
                    >
                        {externalLinks.map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center gap-2 whitespace-nowrap px-[11px] text-[16px] font-semibold leading-[14px] text-[#004961] transition-colors hover:text-[#001a2d]"
                            >
                                <span className="leading-none">{item.label}</span>
                                {item.hasArrow ? <span className="text-[10px] leading-none">&#9662;</span> : null}
                            </a>
                        ))}
                        <NavLink
                            to="/"
                            className={({ isActive }) =>
                                `whitespace-nowrap px-[11px] text-[16px] font-semibold leading-[14px] transition-colors ${isActive ? "text-[#001a2d]" : "text-[#004961] hover:text-[#001a2d]"
                                }`
                            }
                            end
                        >
                            Umfrage
                        </NavLink>
                        <a
                            href={contactLink.href}
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-2 whitespace-nowrap px-[11px] text-[16px] font-semibold leading-[14px] text-[#004961] transition-colors hover:text-[#001a2d]"
                        >
                            <span className="leading-none">{contactLink.label}</span>
                        </a>
                    </nav>
                </div>
            </div>
        </header>
    );
}

export default SiteHeader;
